var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { buildRenderers, transformSource } from '@vtblife/react-markdown-renderers';
import { buildClassName } from '@vtblife/react-markdown-styles/dist/build-class-name';
import stylesDefault from '@vtblife/react-markdown-styles/dist/markdown.module.css';
import { ImageSizeType, MarkdownSize, notInlineTypes } from '@vtblife/react-markdown-types';
import { useMarkdownBreakpointsSettings } from '@vtblife/react-markdown-utils';
import { markdownPlugins } from '@vtblife/remark-plugins-preset';
import cn from 'classnames';
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
export var Markdown = function Markdown(_a) {
  var source = _a.source,
    startHeader = _a.startHeader,
    minimalHeadingStyleLevel = _a.minimalHeadingStyleLevel,
    _a$colorVariant = _a.colorVariant,
    colorVariant = _a$colorVariant === void 0 ? 'white' : _a$colorVariant,
    _a$sizeVariant = _a.sizeVariant,
    sizeVariant = _a$sizeVariant === void 0 ? MarkdownSize.Large : _a$sizeVariant,
    _a$footnote = _a.footnote,
    footnote = _a$footnote === void 0 ? false : _a$footnote,
    _a$imageSize = _a.imageSize,
    imageSize = _a$imageSize === void 0 ? ImageSizeType.Original : _a$imageSize,
    _a$inline = _a.inline,
    inline = _a$inline === void 0 ? false : _a$inline,
    _a$styles = _a.styles,
    styles = _a$styles === void 0 ? stylesDefault : _a$styles,
    newRenderers = _a.renderers,
    classNames = _a.classNames,
    paddingSize = _a.paddingSize,
    unorderedListStyle = _a.unorderedListStyle,
    linkFrom = _a.linkFrom,
    breakpoints = _a.breakpoints,
    props = __rest(_a, ["source", "startHeader", "minimalHeadingStyleLevel", "colorVariant", "sizeVariant", "footnote", "imageSize", "inline", "styles", "renderers", "classNames", "paddingSize", "unorderedListStyle", "linkFrom", "breakpoints"]);
  if (footnote) {
    startHeader = 4;
  }
  var rendererBreakpoints = useMarkdownBreakpointsSettings(Object.assign({
    breakpoints: breakpoints,
    footnote: footnote,
    colorVariant: colorVariant,
    paddingSize: paddingSize
  }, {
    minimalHeadingStyleLevel: minimalHeadingStyleLevel,
    sizeVariant: sizeVariant
  }));
  var renderers = useMemo(function () {
    return Object.assign(Object.assign(Object.assign({}, buildRenderers(Object.assign(Object.assign({
      startHeader: startHeader
    }, {
      minimalHeadingStyleLevel: minimalHeadingStyleLevel,
      sizeVariant: sizeVariant
    }), {
      styles: styles,
      classNames: classNames,
      linkFrom: linkFrom,
      breakpoints: rendererBreakpoints.renderersBreakpoints
    }))), newRenderers), (newRenderers === null || newRenderers === void 0 ? void 0 : newRenderers.heading) && {
      heading: function heading(props) {
        return React.createElement(newRenderers.heading, Object.assign(Object.assign({}, props), {
          startHeader: startHeader,
          breakpoints: rendererBreakpoints.renderersBreakpoints
        }));
      }
    });
  }, [startHeader, minimalHeadingStyleLevel, styles, classNames, linkFrom, newRenderers, sizeVariant, rendererBreakpoints]);
  return React.createElement(ReactMarkdown, Object.assign({}, props, {
    className: cn(buildClassName({
      footnote: footnote,
      imageSize: imageSize,
      inline: inline,
      styles: styles,
      unorderedListStyle: unorderedListStyle,
      breakpoints: rendererBreakpoints.classNamesBreakpoints
    }), props.className),
    disallowedTypes: inline ? notInlineTypes : [],
    renderers: renderers,
    source: transformSource(source),
    plugins: markdownPlugins
  }));
};